import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RoutingService } from 'src/app/services/routing.service';
import { MediaService } from 'src/app/services/media.service';
import { ROUTE_PATH_GIFT_USE } from 'src/app/app-routing.constants';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentComponent {
  @Input() orderId?: string;

  @Input() giftId?: string;

  get giftUsePath(): string {
    return this.giftId ? `/${ROUTE_PATH_GIFT_USE}/${this.giftId}` : '';
  }

  get location() {
    return location;
  }

  constructor(public routing: RoutingService, public media: MediaService) {}
}
